import useIsAdmin from '../../hooks/useIsAdmin';
import { IChildrenProps } from '../../models/utilTypes';
// ghost
const AdminOnly: React.FC<IChildrenProps> = ({ children }) =>
  useIsAdmin() ? <>{children}</> : null;

export default AdminOnly;
